import React from "react";
import { Link } from "react-router-dom";

/**
 * Let's Siva CPI wordmark header. Placeholder text lockup — swap the
 * <span data-brand="wordmark"> content with an <img src=".../logo.svg" /> once
 * the final logo file is provided (keep the ™ mark legible).
 */
export const BrandHeader = ({ subtitle, right = null, minimal = false }) => {
  return (
    <header
      data-testid="brand-header"
      className="w-full border-b border-neutral-200 bg-[#FAF7F2]/95 backdrop-blur supports-[backdrop-filter]:bg-[#FAF7F2]/80 sticky top-0 z-30"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 no-underline" data-testid="brand-home-link">
          <img
            src="/brand/lets-siva-logo.png"
            alt="Let's Siva™"
            className="h-10 sm:h-12 w-auto select-none"
            draggable={false}
            data-testid="brand-logo"
          />
          {!minimal && (
            <>
              <span className="hidden sm:inline-block mx-1 h-8 w-px bg-neutral-300" aria-hidden />
              <span className="hidden sm:inline text-sm sm:text-base font-medium text-neutral-700">
                CPI<span className="text-[10px] align-super font-medium text-neutral-500 ml-0.5">™</span>{" "}
                Digital Logsheet
              </span>
            </>
          )}
        </Link>
        <div className="flex items-center gap-2">{right}</div>
      </div>
      {subtitle && (
        <div className="max-w-4xl mx-auto px-4 sm:px-6 pb-3 text-xs text-neutral-500">{subtitle}</div>
      )}
    </header>
  );
};

export default BrandHeader;
